import { useContext, useState } from "react";
import {
  useGetLocale,
  useSetLocale,
  useTranslate,
} from "@refinedev/core";
import { HamburgerMenu, RefineThemedLayoutV2HeaderProps } from "@refinedev/mui";

import {
  AppBar,
  IconButton,
  Avatar,
  Typography,
  Toolbar,
  Stack,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import {
  DarkModeOutlined,
  LightModeOutlined,
} from "@mui/icons-material";

import i18n from "../../I18n";
import { ColorModeContext } from "../../contexts/color-mode";
import dayjs from "dayjs";

export const Header: React.FC<RefineThemedLayoutV2HeaderProps> = () => {
  // Header is disabled - returning null to hide it
  return null;
};
